import React from 'react'
import {Container, Row, Col, Form} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import FormPass from 'components/componentsmall/form_pass'
import FormInput from 'components/componentsmall/form_input'
import './style.css'

export default function Index() {
    return (
        <Container className="login-berberkah">
            <Row>
                <Col md={6}>
                    <Form>
                        <h3>Masuk</h3>
                        <FormInput lable="Nomor HP" place="Nomor HP Anda" />
                        <FormPass lablePass="Kata sandi" placePass="Kata Sandi Anda" />
                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                            <Form.Check type="checkbox" label="Check me out" />
                            <Link to="">Lupa kata sandi</Link>
                        </Form.Group>
                        <div className="tombol-login">
                            <button type="button">Masuk</button>
                            <p>atau masuk dengan</p>
                            <button className="google" type="button"> <img src="asset/home/icons/google.svg" alt="google" /> Google</button>
                            <p>Butuh Bantuan? <Link to="#">Hubungi Kami</Link></p>
                        </div>
                    </Form>
                </Col>
                <Col md={6}>
                    <div className="img-login">
                        <img src="asset/berberkah/login-cart.png" alt="login" />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
